import "@/App.css";
import { Hero } from "@/components/Hero";
import { Understood } from "@/components/Understood";
import { Topics } from "@/components/Topics";
import { ForYou } from "@/components/ForYou";
import { MeetSawyer } from "@/components/MeetSawyer";
import { FinalCta } from "@/components/FinalCta";

function App() {
  return (
    <div data-testid="webinar-landing-page" className="font-body bg-cream min-h-screen">
      <Hero />
      <Understood />
      <Topics />
      <ForYou />
      <MeetSawyer />
      <FinalCta />
      <footer data-testid="site-footer" className="bg-cream py-8 text-center text-sm text-stone-muted">
        © Sawyer Fast
      </footer>
    </div>
  );
}

export default App;
